import { render, staticRenderFns } from "./ServerBundlesTable.vue?vue&type=template&id=d2e33ffa"
import script from "./ServerBundlesTable.vue?vue&type=script&lang=js"
export * from "./ServerBundlesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports